import React, { useEffect } from "react";

const Fancybox = (props: {
  id: string;
  href?: string;
  dataType?: string;
  dataSrc?: string;
  children: JSX.Element;
}) => {
  useEffect(() => {
    try {
      // @ts-ignore
      $(`.pyht-fancybox#${props.id}`).fancybox({
        showNavArrows: false,
        baseClass: "pyht-fancybox-container",
      });
    } catch (e) {
      console.warn(
        "Cannot initialise nice-select for PYHT: jQuery not available!"
      );
    }
  }, []);
  return (
    <a
      id={props.id}
      className={"pyht-fancybox"}
      href={props.href}
      data-fancybox
      data-type={props.dataType}
      data-src={props.dataSrc}
    >
      {props.children}
    </a>
  );
};

export default Fancybox;
